import Vue from 'vue'

const textRulesUrl = '/traveller/restui/realtime/textrules/'

const postConfig = {
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    }
}

const replacementRules = {
    namespaced: true,
    state: {
        replacementRuleConfigs: null,
        replacementRules: null,
        replacementRuleExamples: null
    },
    getters: {
        getReplacementRuleConfigs(state) {
            return state.replacementRuleConfigs
        },
        getReplacementRules:(state) => (configId , ruleType) => {
            if( state.replacementRules == undefined ) return []

            const ruleMap = state.replacementRules[configId]
            if( ruleMap == undefined ) return []
            
            const rules = ruleMap[ruleType]
            if( rules == undefined ) return []
            
            return rules
        },
        getReplacementRule:(state) => (ruleId) => {
            if( state.replacementRules == null ) return []
            for( const configMap of Object.values(state.replacementRules) ) {
                for( const rules of Object.values(configMap ) ) {
                    for( let rule of rules ) {
                        if( rule.id == ruleId ) {
                            return rule
                        }
                    }
                }
            }
            return []
        },
        getRuleExamples:(state) => (ruleType) => {
            if( state.replacementRuleExamples == null )
                return []
            const examples = state.replacementRuleExamples[ruleType]
            if( examples == undefined ) return []

            return examples
        }
    },
    mutations: {
        reset(state) {
            state.replacementRuleConfigs = null
            state.replacementRules = null
        },
        replacementRuleConfigs(state , newItem ) {
            state.replacementRuleConfigs = newItem
        },
        setRules( state , rules ) {
            
            if( state.replacementRules == null || state.replacementRules == undefined) {         
                state.replacementRules = {}
            }
            
            const configId = rules.params.configurationId
            const ruleType = rules.params.ruleType
            
            let config = state.replacementRules[configId]
            
            if( config == undefined || config == null) {
                
                config = {}
                Vue.set(state.replacementRules,configId , config )
            }
            Vue.set(config , ruleType , rules.data )
        },
        setRuleExamples( state , examples ) {
            if( state.replacementRuleExamples == null || state.replacementRuleExamples == undefined )
                state.replacementRuleExamples = {}
            Vue.set( state.replacementRuleExamples, examples.ruleType, examples.data )
        }
    },
    actions: {
        getReplacementRuleConfigs(context) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get(textRulesUrl+"textReplacementConfigurationList")
                .then( (response) => {
                    if( response.status == 200 ) {
                        context.commit('replacementRuleConfigs' , response.data )
                        resolve( context.state.replacementRuleConfigs)
                    } else {
                        reject()
                    }
                    
                }).catch((error) => {
                    reject(error)
                }) 
            })
        },
        addReplacementRuleConfig(context , newItem ) {
            return new Promise((resolve , reject ) => {
                // Make copy of new item and remove id from object
                const newConfig = { ...newItem }
                delete newConfig.id
                postItemUpdate.call(this, newConfig, context, resolve, reject)
            })
        },
        removeReplacementRuleConfig( context, replacementRuleConfigId ) {
            return new Promise((resolve, reject ) => {
                let params = { ...postConfig }
                    params.params = { 'configurationId' : replacementRuleConfigId }
                this._vm.$traveller_http.post(textRulesUrl+"removeTextConfiguration" , 
                    null, params ).then( (response) => {
                    if( response.status == 200 ) {
                        context.dispatch('getReplacementRuleConfigs').then(() => {
                            resolve()
                        }).catch( (error) => {
                            reject(error)
                        })   
                    }
                }).catch((error) => { reject(error)})
            })
        },
        updateReplacementRuleConfig( context , replacementConfig ) {  
            return new Promise((resolve , reject ) => {
                if( replacementConfig.id == undefined ) {
                    reject("Id is undefined")
                }
                postItemUpdate.call(this, replacementConfig, context, resolve, reject)
            })
        },
        loadRules( context , params ) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get(textRulesUrl + "textReplacementRules" , { params: params }).then((response) => {
                    if( response.status == 200 ) {
                        const newRules = {
                            params: params,
                            data: response.data
                        }
                        context.commit('setRules' , newRules )
                        resolve()
                    } 
                } ).catch(() => {
                    reject()
                })
            })
        },
        loadRuleExamples( context , params ) {
            const ruleType = params.ruleType
            return new Promise((resolve,reject) => {
                this._vm.$traveller_http.get(textRulesUrl + "ruleExamples", { params: params }).then((response) => {
                    if( response.status == 200 ) {
                        const newExamples = {
                            ruleType:ruleType,
                            data: response.data
                        }
                        context.commit('setRuleExamples', newExamples )
                        resolve()
                    }
                } ).catch(() => {
                    reject()
                })
            })
        },
        createReplacementRule(context , newRule ) {
            const config = newRule.ruleConfigurationId
            const ruleType = newRule.type
            return new Promise((resolve, reject) => {
                postRuleUpdate.call(this, newRule, context, config, ruleType, resolve, reject)
            })
        },
        updateReplacementRule( context, updatedRule ) {
            const config = updatedRule.ruleConfigurationId
            const ruleType = updatedRule.type
            return new Promise((resolve, reject) => {
                postRuleUpdate.call(this, updatedRule, context, config, ruleType, resolve, reject)
            })
        },
        deleteReplacementRule( context , ruleId ) {
           
            return new Promise((resolve,reject) => {
                
                const rule = context.getters['getReplacementRule'](ruleId)
                const configurationId = rule.ruleConfigurationId
                const ruleType = rule.type

                let params = { ...postConfig }
                params.params = { 'ruleId' : ruleId }
                
                
                return this._vm.$traveller_http.post( textRulesUrl + "deleteReplacementRule" ,{}, params ).then((response) => {
                    if( response.status == 200 ) {
                        
                        const params =  { 
                            configurationId:configurationId,
                            ruleType:ruleType }
                  
                        return context.dispatch('loadRules', params ).then(() => {
                            resolve()
                        }).catch((error) => {
                            console.log("Load rules rejected")
                            reject(error)
                        }) 
                    } else {
                        reject()
                    }
                } ).catch( (error) => {
                    console.log("Error deleting rule")
                    reject(error)
                }) 
            })
        }
    }   
}

export default replacementRules

function postRuleUpdate( newRule, context, config, ruleType, resolve, reject) {
    this._vm.$traveller_http.post(textRulesUrl + "updateReplacementRule", newRule).then((response) => {
        if (response.status == 200) {
            context.dispatch('loadRules', { configurationId: config, ruleType: ruleType }).then(() => {
                resolve()
            }).catch(() => {
                reject()
            })
        }
    }).catch(() => {
        reject()
    })
}

function postItemUpdate(newConfig, context, resolve, reject) {
    this._vm.$traveller_http.post(textRulesUrl + "updateTextConfiguration", newConfig, postConfig).then((response) => {
        if (response.status == 200) {
            context.dispatch('getReplacementRuleConfigs').then(() => {
                resolve()
            }).catch((error) => {
                reject(error)
            })
        }
    }).catch((error) => {
        reject(error)
    })
}
